import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getClientId } from '../../index';
export { validateEmailAddress };
var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ValidateEmailAddress($email: String!, $clientId: String!) {\n    validateEmailAddress(email: $email, clientId: $clientId) {\n      status\n    }\n  }\n"])));
function validateEmailAddress(_x) {
  return _validateEmailAddress.apply(this, arguments);
}
function _validateEmailAddress() {
  _validateEmailAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(email) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('validateEmailAddress', query, {
            email: email,
            clientId: getClientId()
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.validateEmailAddress);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _validateEmailAddress.apply(this, arguments);
}